import EggsProduct from 'models/EggsProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import EggsPackage from './EggsPackage'

const productOptions = {
  packagingInfo: <EggsPackage />,
  productTitle: 'Cage Free Eggs (Large White Only)',
  model: EggsProduct,
  validCategories: ['03'],
  validSubCategories: ['005'],
}

const Eggs = () => <ProductForm product={productOptions} />

export default Eggs
